import React, { useState, useEffect } from "react";
import "./CoachModal.css";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import ProfileImageUploader from "../ProfileImageUploader/ProfileImageUploader";
import { CoachPreviewDrawer } from "../CoachPreviewDrawer/CoachPreviewDrawer";
import { AddBadge, GetBadges } from "../../../../api/AdminCoachPanel/coachApis";
import { toast } from "react-toastify";
import ExamCategoryType from "../../../../enums/ExamCategoryType";

const MAX_BADGES = 8;

const EXAM_CATEGORY_OPTIONS = [
  { id: ExamCategoryType.YKS, label: "YKS" },
  { id: ExamCategoryType.LGS, label: "LGS" },
];

export default function CoachModal({
  isOpen,
  mode,
  coach,
  onClose,
  onSave,
  selectedCoachOrder,
  coachStudentCount,
}) {
  const user = JSON.parse(localStorage.getItem("user"));
  const userAdminToken = sessionStorage.getItem("jwtP");
  const FIXED_RANK_TYPES = [
    { label: "TYT", code: "TYT" },
    { label: "Sayısal", code: "SAY" },
    { label: "Sözel", code: "SÖZ" },
    { label: "Eşit Ağırlık", code: "EA" },
    { label: "Dil", code: "DİL" },
  ];

  /* ------------------------------------ */
  /*   1) INITIAL VALUES (NO HOOKS YET)   */
  /* ------------------------------------ */
  // const initialOrder = coach && selectedCoachOrder ? selectedCoachOrder : 1
  const hasCoach = coach && coach.CoachDetail;

  const initialExamCategoryId =
  coach && coach.ExamCategoryId !== undefined
    ? coach.ExamCategoryId
    : ExamCategoryType.YKS;


  const initialName = coach && coach.Name ? coach.Name : "";
  const initialSurname = coach && coach.Surname ? coach.Surname : "";
  const initialProfilePicture =
    coach && coach.ProfilePictureUrl ? coach.ProfilePictureUrl : "";

  // Extract JUST the filename part (anything after last "/")
  const initialProfileVideo =
    hasCoach && coach.CoachDetail.ProfileVideoUrl1
      ? coach.CoachDetail.ProfileVideoUrl1.split("/")
          .pop()
          .replace(/\.[^/.]+$/, "")
      : "";

  const initialUniversity =
    hasCoach && coach.CoachDetail.UniversityName
      ? coach.CoachDetail.UniversityName
      : "";

  const initialMajor =
    hasCoach && coach.CoachDetail.MajorName ? coach.CoachDetail.MajorName : "";

  const initialAbout =
    hasCoach && coach.CoachDetail.AboutMe ? coach.CoachDetail.AboutMe : "";

  const initialRemainingSeats =
    hasCoach && coach.CoachDetail.RemainingSeats !== undefined
      ? coach.CoachDetail.RemainingSeats
      : 0;

  const initialTotalSeats =
    hasCoach && coach.CoachDetail.TotalSeat !== undefined
      ? coach.CoachDetail.TotalSeat
      : 0;

  const initialCoachOrder =
    hasCoach && coach.Order !== undefined ? coach.Order : 1;

  console.log("initialCoachOrder", initialCoachOrder);

  const initialIsSelectedCoach =
    hasCoach && coach.CoachDetail.IsSelectedCoach ? true : false;

  const initialBadges =
    hasCoach && coach.CoachDetail.Badges && coach.CoachDetail.Badges.length
      ? coach.CoachDetail.Badges
      : [];

  // const initialRanks =
  //   coach && coach.CoachRanks && coach.CoachRanks.length
  //     ? coach.CoachRanks
  //     : [];

  const initialEmail = coach && coach.Email ? coach.Email : "";

  const initialPhone = coach && coach.PhoneNumber ? coach.PhoneNumber : "";

  const initialRanks = FIXED_RANK_TYPES.map(function (rt) {
    const coachRanks = coach && coach.CoachRanks ? coach.CoachRanks : [];

    const found = coachRanks.find(function (r) {
      return (
        r &&
        r.ExamSubType &&
        r.ExamSubType.toLowerCase() === rt.code.toLowerCase()
      );
    });

    return {
      Id: found && found.Id ? found.Id : new Date().getTime() + Math.random(),
      ExamSubType: rt.code,
      Rank:
        found && found.Rank
          ? parseInt(String(found.Rank).replace(/\D/g, ""), 10)
          : "",
      VisibleOnPreview:
        found && found.VisibleOnPreview ? found.VisibleOnPreview : false,
      VisibleOnSummary:
        found && found.VisibleOnSummary ? found.VisibleOnPreview : false,
    };
  });

  const initialMode = mode || "edit";

  const VIDEO_BASE_URL =
    "https://d2cqobm8wcb2vo.cloudfront.net/content/coachingvideos/";

  /* ------------------------------------ */
  /*         2) HOOKS (ALWAYS RUN)        */
  /* ------------------------------------ */

  const [name, setName] = useState(initialName);
  const [surname, setSurname] = useState(initialSurname);
  const [profilePictureUrl, setProfilePictureUrl] = useState(
    initialProfilePicture
  );
  // const [profileVideoUrl, setProfileVideoUrl] =
  //   useState(initialProfileVideo);
  const [profileVideoFilename, setProfileVideoFilename] =
    useState(initialProfileVideo);
  const [videoPreviewUrl, setVideoPreviewUrl] = useState(null);

  const [university, setUniversity] = useState(initialUniversity);
  const [major, setMajor] = useState(initialMajor);
  const [aboutMe, setAboutMe] = useState(initialAbout);
  const [totalSeats, setTotalSeats] = useState(initialTotalSeats);
  const [isSelectedCoach, setIsSelectedCoach] = useState(
    initialIsSelectedCoach
  );
  const [badges, setBadges] = useState(initialBadges);
  const [ranks, setRanks] = useState(initialRanks);
  const [email, setEmail] = useState(initialEmail);
  const [phone, setPhone] = useState(initialPhone);
  // function handleChangeRank(id, field, value) {
  //   setRanks(ranks.map(r =>
  //     r.Id === id ? { ...r, [field]: parseInt(value, 10) } : r
  //   ));
  // }
  const [selectedExamCategoryId, setSelectedExamCategoryId] = useState(
    initialExamCategoryId
  );
  var [showBadgeDropdown, setShowBadgeDropdown] = useState(false);
  const [isAddingBadge, setIsAddingBadge] = useState(false);
  const [newBadgeName, setNewBadgeName] = useState("");
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [previewPayload, setPreviewPayload] = useState(null);
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [coachOrder, setCoachOrder] = useState(initialCoachOrder);

  const [availableBadges, setAvailableBadges] = useState([]);
  const [badgeLoading, setBadgeLoading] = useState(false);

  const getBadgeList = async function () {
    try {
      setBadgeLoading(true);

      const res = await GetBadges(userAdminToken);

      if (res && res.data && res.data.ResponseStatus === 1) {
        setAvailableBadges(res.data.ResponseData || []);
      } else {
        toast.error(res.data.ResponseMessage);
        console.error("Badge list failed", res);
      }
    } catch (err) {
      console.error("GetBadges error", err);
    } finally {
      setBadgeLoading(false);
    }
  };

  /* ---------------------------------------------- */
  /*       3) EFFECT — sync state when coach loads  */
  /* ---------------------------------------------- */

  useEffect(
    function () {
      if (isOpen) {
        getBadgeList();
      }
    },
    [isOpen]
  );

  useEffect(
    function () {
      setName(initialName);
      setSurname(initialSurname);
      setProfilePictureUrl(
        coach && coach.ProfilePictureUrl ? coach.ProfilePictureUrl : null
      );

      setProfileVideoFilename(initialProfileVideo);
      setUniversity(initialUniversity);
      setMajor(initialMajor);
      setAboutMe(initialAbout);
      setTotalSeats(initialTotalSeats);
      setIsSelectedCoach(initialIsSelectedCoach);
      setBadges(initialBadges);
      setRanks(initialRanks);
      setEmail(initialEmail);
      setPhone(initialPhone);
      setCoachOrder(initialCoachOrder);
      setSelectedExamCategoryId(initialExamCategoryId);
    },
    [coach]
  );

  /* ------------------------------- */
  /*       4) CLOSE ON ESC           */
  /* ------------------------------- */

  useEffect(
    function () {
      function onKey(e) {
        if (e.keyCode === 27 || e.key === "Escape") {
          if (isPreviewOpen) {
            setIsPreviewOpen(false);
          } else if (onClose) {
            onClose();
          }
        }
      }

      document.addEventListener("keydown", onKey);
      return function () {
        document.removeEventListener("keydown", onKey);
      };
    },
    [onClose, isPreviewOpen]
  );

  useEffect(() => {
    if (!profileVideoFilename || profileVideoFilename.trim() === "") {
      setVideoPreviewUrl(null);
      return;
    }

    const handle = setTimeout(() => {
      const fullUrl =
        "https://d2cqobm8wcb2vo.cloudfront.net/content/coachingvideos/" +
        profileVideoFilename +
        ".mp4";

      setVideoPreviewUrl(fullUrl);
    }, 500); // wait 500ms after typing stops

    return () => clearTimeout(handle);
  }, [profileVideoFilename]);

  /* ------------------------------- */
  /*       5) ACTION HANDLERS        */
  /* ------------------------------- */

  const fullVideoUrl =
    profileVideoFilename && profileVideoFilename.length > 2
      ? VIDEO_BASE_URL + profileVideoFilename
      : null;

  const studentCount = coachStudentCount;
  console.log("coachStudentCount", coachStudentCount);

  function handleRemoveBadge(id) {
    setBadges(
      badges.filter(function (b) {
        // existing badges → only unselect
        if (!b.isNew) return true;

        // new badges → allow full removal
        return b.Id !== id;
      })
    );

    setAvailableBadges(
      availableBadges.filter(function (b) {
        if (!b.isNew) return true;
        return b.Id !== id;
      })
    );
  }

  function handleAddRank() {
    const newRank = {
      Id: new Date().getTime(),
      Rank: "",
      ExamSubType: "",
    };
    setRanks(ranks.concat([newRank]));
  }

  function handleChangeRank(id, field, value) {
    setRanks(
      ranks.map(function (r) {
        if (r.Id !== id) return r;

        return {
          Id: r.Id,
          ExamSubType: r.ExamSubType,
          Rank:
            field === "Rank"
              ? value === ""
                ? null
                : parseInt(value, 10)
              : r.Rank,
          VisibleOnPreview:
            field === "VisibleOnPreview" ? value : r.VisibleOnPreview,
          VisibleOnSummary:
            field === "VisibleOnSummary" ? value : r.VisibleOnSummary,
        };
      })
    );
  }

  function handleEmailChange(value) {
    const trimmed = value.trim();
    setEmail(trimmed);

    // simple but correct email regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!trimmed) {
      setEmailError("Email giriniz");
    } else if (!emailRegex.test(trimmed)) {
      setEmailError("Geçersiz Email Formatı");
    } else {
      setEmailError("");
    }
  }

  function handlePhoneChange(value) {
    // remove everything except digits
    const digitsOnly = value.replace(/\D/g, "");

    // max 10 digits
    const limited = digitsOnly.slice(0, 10);

    setPhone(limited);

    if (!limited) {
      setPhoneError("Telefon numarası ekleyiniz");
    } else if (limited.length !== 10) {
      setPhoneError("Telefon numarası 10 hane olmalıdır");
    } else {
      setPhoneError("");
    }
  }

  function handleDeleteRank(id) {
    setRanks(
      ranks.filter(function (r) {
        return r.Id !== id;
      })
    );
  }

  function handleBackdropClick(e) {
    if (e.target === e.currentTarget) {
      if (onClose) onClose();
    }
  }

  function buildPayload() {
    return {
      ExamCategoryId: selectedExamCategoryId,
      Id: coach && coach.Id ? coach.Id : undefined,
      Order: Number(coachOrder),
      Name: name,
      Surname: surname,
      ProfilePictureUrl: profilePictureUrl,
      Email: email,
      PhoneNumber: phone,
      CoachDetail: {
        ProfileVideoUrl1:
        profileVideoFilename?"https://d2cqobm8wcb2vo.cloudfront.net/content/coachingvideos/" +
          profileVideoFilename +
          ".mp4":null, // or whatever you named it
        UniversityName: university,
        MajorName: major,
        AboutMe: aboutMe,
        TotalSeat: Number(totalSeats),
        IsSelectedCoach: isSelectedCoach,
        Badges: badges,
      },
      CoachRanks: ranks
        .filter(function (r) {
          return typeof r.Rank === "number" && r.Rank > 0;
        })
        .map(function (r) {
          return {
            Id: r.Id,
            ExamSubType: r.ExamSubType,
            Rank: r.Rank,
            VisibleOnPreview: !!r.VisibleOnPreview,
            VisibleOnSummary: !!r.VisibleOnSummary,
          };
        }),
      RowStatus: true,
    };
  }

  function handleOpenPreview() {
    let hasError = false;

    if (!email) {
      setEmailError("Email giriniz");
      hasError = true;
    }

    if (!phone) {
      setPhoneError("Telefon numarası ekleyiniz");
      hasError = true;
    }

    if (emailError || phoneError) {
      hasError = true;
    }

    if (hasError) return;

    var payload = buildPayload();
    setPreviewPayload(payload);
    setIsPreviewOpen(true);
  }

  function handleConfirmSave() {
    if (onSave && previewPayload) {
      onSave(previewPayload, mode);
    }
    setIsPreviewOpen(false);
  }

  function handleCancelPreview() {
    setIsPreviewOpen(false);
  }

  function handleToggleBadge(badge) {
    var exists = badges.some(function (b) {
      return b.Id === badge.Id;
    });

    if (exists) {
      // If badge is NEW → remove completely
      if (badge.isNew) {
        handleRemoveBadge(badge.Id);
        return;
      }

      // Existing badge → just unselect
      setBadges(
        badges.filter(function (b) {
          return b.Id !== badge.Id;
        })
      );
    } else {
      // ⛔ BLOCK if max reached
      if (badges.length >= MAX_BADGES) {
        return;
      }
      // Select badge
      setBadges(badges.concat([badge]));
    }
  }

  /* ----------------------------------- */
  /*       6) RETURN (SAFE AREA)         */
  /* ----------------------------------- */

  if (!isOpen) {
    return null;
  }

  const title =
    initialMode === "create" ? "Yeni Koç Ekle" : "Koç Profili Düzenle";

  const subtitle =
    initialMode === "create"
      ? "Yeni Koç Profili Oluştur."
      : "Seçilen Koçun Profil Bilgilerini Düzenle";

  function handleCreateNewBadge() {
    if (badges.length >= MAX_BADGES) {
      return;
    }
    const name = newBadgeName.trim();
    if (!name) {
      setIsAddingBadge(false);
      setNewBadgeName("");
      return;
    }

    const tempBadge = {
      Id: "temp-" + Date.now() + "-" + Math.random(),
      Name: name,
      isNew: true, // ⭐ IMPORTANT
    };

    setBadges(badges.concat([tempBadge]));
    setAvailableBadges(availableBadges.concat([tempBadge]));

    setNewBadgeName("");
    setIsAddingBadge(false);
  }

  function cancelNewBadge() {
    setNewBadgeName("");
    setIsAddingBadge(false);
  }

  // const  toTitleCase = (str) =>  {
  //   return str
  //     .toLowerCase()
  //     .split(" ")
  //     .filter(Boolean)
  //     .map(word => word.charAt(0).toUpperCase() + word.slice(1))
  //     .join(" ");
  // }
  const toTitleCase = (str) => {
    // Detect if user has typed a trailing space
    const endsWithSpace = str.endsWith(" ");

    // Normalize spacing (remove extra internal spaces)
    let parts = str
      .split(" ")
      .filter(Boolean)
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());

    // Rebuild string
    let result = parts.join(" ");

    // If user typed a space, preserve it
    if (endsWithSpace) result += " ";

    return result;
  };

  function toTitleCaseWithTrailingSpace(str) {
    const endsWithSpace = str.endsWith(" ");

    let parts = str
      .split(" ")
      .filter(Boolean)
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());

    let result = parts.join(" ");

    if (endsWithSpace) result += " ";

    return result;
  }

  return (
    <div className="coach-modal-backdrop" onClick={handleBackdropClick}>
      <div className="coach-modal-dialog">
        {/* HEADER */}
        <div className="coach-modal-header">
          <div className="coach-modal-header-text">
            <h1 className="coach-modal-title">{title}</h1>
            <p className="coach-modal-subtitle">{subtitle}</p>
          </div>

          <button
            className="coach-modal-close-btn"
            onClick={function () {
              if (onClose) onClose();
            }}
          >
            <span className="material-symbols-outlined">x</span>
          </button>
        </div>

        {/* BODY */}
        <div className="coach-modal-body">
          {/* LEFT COLUMN */}
          <div className="coach-modal-column">
            {/* <div className="coach-modal-avatar-row">
              <div className="coach-modal-avatar-wrap">
              <ProfileImageUploader
  initialImage={profilePictureUrl}
  onUploadComplete={setProfilePictureUrl}
/>


                <div className="coach-modal-avatar-text">
                  <p className="coach-modal-avatar-title">
                    Profile Picture
                  </p>
                  <p className="coach-modal-avatar-subtitle">
                    PNG, JPG, GIF up to 10MB
                  </p>
                </div>
              </div>

              <button
                type="button"
                className="coach-modal-upload-btn"
                onClick={function () {
                  const url = window.prompt(
                    "Enter image URL",
                    profilePictureUrl
                  );
                  if (url !== null) setProfilePictureUrl(url);
                }}
              >
                Upload Image
              </button>
            </div> */}
            {/* PROFILE IMAGE UPLOADER */}
            <div className="coach-modal-profile-image-section">
              <p className="coach-modal-label">Profil Resmi</p>

              <ProfileImageUploader
                initialImage={profilePictureUrl}
                onUploadComplete={setProfilePictureUrl}
              />

              <p className="coach-modal-helper-text">JPG / PNG — Max 100 KB</p>
            </div>

            {/* NAME + SURNAME */}
            <div className="coach-modal-row-two">
              <label className="coach-modal-field">
                <p className="coach-modal-label">İsim</p>
                <input
                  className="coach-modal-input"
                  value={name}
                  onChange={(e) => {
                    let value = e.target.value;

                    // Allow only letters & spaces (Turkish chars included)
                    value = value.replace(/[^a-zA-ZçğıöşüÇĞİÖŞÜ\s]/g, "");

                    // Convert to title case
                    value = toTitleCaseWithTrailingSpace(value);

                    setName(value);
                  }}
                />
              </label>

              <label className="coach-modal-field ">
                <p className="coach-modal-label">Soyisim</p>
                <input
                  className="coach-modal-input "
                  value={surname}
                  onChange={(e) => {
                    let value = e.target.value;

                    // Only letters allowed
                    value = value.replace(/[^a-zA-ZçğıöşüÇĞİÖŞÜ\s]/g, "");

                    // Capitalize first letter only
                    value = toTitleCaseWithTrailingSpace(value);

                    setSurname(value);
                  }}
                  // disabled
                />
              </label>
            </div>
            <div>
              <div className="coach-modal-row-two">
                <label className="coach-modal-field">
                  <p className="coach-modal-label">Email</p>
                  <input
                    type="email"
                    className="coach-modal-input"
                    value={email}
                    onChange={(e) => handleEmailChange(e.target.value)}
                  />
                  {emailError && (
                    <p className="coach-modal-error">{emailError}</p>
                  )}
                </label>

                <label className="coach-modal-field">
                  <p className="coach-modal-label">Telefon Numarası</p>
                  <input
                    type="tel"
                    className="coach-modal-input"
                    value={phone}
                    onChange={(e) => handlePhoneChange(e.target.value)}
                    placeholder="5xxxxxxxxx"
                  />
                  {phoneError && (
                    <p className="coach-modal-error">{phoneError}</p>
                  )}
                </label>
              </div>

              {/* 👇 Note goes here */}
              <p className="coach-modal-note">
                Pakodemy hesabına ait email ve telefon numarası
              </p>
            </div>

            {/* PROFILE VIDEO */}
            {/* <label className="coach-modal-field">
              <p className="coach-modal-label">Profile Video URL</p>
              <input
                className="coach-modal-input"
                placeholder="https://youtube.com/..."
                value={profileVideoUrl}
                onChange={function (e) {
                  setProfileVideoUrl(e.target.value);
                }}
              />
            </label> */}

            <label className="coach-modal-field">
              <p className="coach-modal-label">Profil Video Dosya Adı</p>

              <input
                className="coach-modal-input"
                placeholder="örnek: batuhanh"
                value={profileVideoFilename}
                onChange={(e) => setProfileVideoFilename(e.target.value.trim())}
              />

              {/* LIVE VIDEO PREVIEW */}
              {videoPreviewUrl && (
                <video
                  src={videoPreviewUrl}
                  controls
                  style={{
                    width: "100%",
                    // height:"30%",
                    height: "200px",
                    marginTop: "10px",
                    borderRadius: "8px",
                    backgroundColor: "#000",
                  }}
                />
              )}
            </label>

            {/* UNIVERSITY + MAJOR */}
            <div className="coach-modal-row-two">
              <label className="coach-modal-field">
                <p className="coach-modal-label">Birinci Başlık(Üniversite)</p>
                <input
                  placeholder="örn: Psikolojik Danışman"
                  className="coach-modal-input"
                  value={university}
                  onChange={(e) => {
                    let value = e.target.value.slice(0, 50); // limit to 50 chars
                    value = value.replace(/[^a-zA-ZçğıöşüÇĞİÖŞÜ\s]/g, "");
                    value = toTitleCaseWithTrailingSpace(value);
                    setUniversity(value);
                  }}
                />
              </label>

              <label className="coach-modal-field">
                <p className="coach-modal-label">İkinci Başlık(Bölüm)</p>
                <input
                  placeholder="örn: Rehber Öğretmen"
                  className="coach-modal-input"
                  value={major}
                  onChange={(e) => {
                    let value = e.target.value.slice(0, 50); // limit to 50 chars
                    value = value.replace(/[^a-zA-ZçğıöşüÇĞİÖŞÜ\s]/g, "");
                    value = toTitleCaseWithTrailingSpace(value);
                    setMajor(value);
                  }}
                />
              </label>
            </div>

            {/* ABOUT ME */}
            <label className="coach-modal-field">
              <p className="coach-modal-label">Hakkımda</p>

              <textarea
                className="coach-modal-textarea"
                rows={4}
                value={aboutMe}
                maxLength={550}
                onChange={function (e) {
                  setAboutMe(e.target.value);
                }}
              />
              <div className="char-counter">{aboutMe.length}/550</div>
            </label>
          </div>

          {/* RIGHT COLUMN */}
          <div className="coach-modal-column">
            {/* BADGES */}
            {/* BADGES */}
            <div className="coach-modal-field">
              <p className="coach-modal-label">Etiketler</p>

              <div className="badge-chip-container">
                {availableBadges.map((badge) => {
                  const selected = badges.some((b) => b.Id === badge.Id);
                  const limitReached = badges.length >= MAX_BADGES;

                  const isDisabled = !selected && limitReached;

                  return (
                    <div
                      key={badge.Id}
                      className={
                        "badge-chip " +
                        (selected
                          ? "badge-chip-selected"
                          : "badge-chip-unselected") +
                        (isDisabled ? " badge-chip-disabled" : "")
                      }
                      onClick={() => {
                        if (isDisabled) return;
                        handleToggleBadge(badge);
                      }}
                    >
                      <span>{badge.Name}</span>

                      {selected ? (
                        <CloseIcon className="badge-chip-icon selected-icon" />
                      ) : (
                        <AddIcon className="badge-chip-icon add-icon" />
                      )}
                    </div>
                  );
                })}

                {/* Add Badge Button */}
                {isAddingBadge ? (
                  <div className="badge-chip badge-chip-add-input">
                    <input
                      className="badge-add-input"
                      autoFocus
                      value={newBadgeName}
                      onChange={(e) => setNewBadgeName(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") handleCreateNewBadge();
                        if (e.key === "Escape") cancelNewBadge();
                      }}
                      placeholder="Yeni badge..."
                    />
                    <span
                      className="badge-add-save"
                      onClick={handleCreateNewBadge}
                    >
                      ✓
                    </span>
                  </div>
                ) : (
                  <div
                    className={
                      "badge-chip badge-chip-add " +
                      (badges.length >= MAX_BADGES ? "badge-chip-disabled" : "")
                    }
                    onClick={() => {
                      if (badges.length >= MAX_BADGES) return;
                      setIsAddingBadge(true);
                    }}
                  >
                    <AddIcon className="badge-chip-icon add-icon" />
                    <span>Yeni Badge</span>
                  </div>
                )}
              </div>
              {badges.length >= MAX_BADGES && (
                <p className="coach-modal-error" style={{ marginTop: 6 }}>
                  En fazla {MAX_BADGES} etiket seçebilirsiniz.
                </p>
              )}
            </div>

            {/* RANKS */}
            {/* <div className="coach-modal-ranks-block">
              <p className="coach-modal-label">Ranks</p>

              {ranks.map(function (r) {
                return (
                  <div className="coach-modal-rank-row" key={r.Id}>
                    <input
                      className="coach-modal-input"
                      placeholder="ExamSubType"
                      value={r.ExamSubType || ""}
                      onChange={function (e) {
                        handleChangeRank(
                          r.Id,
                          "ExamSubType",
                          e.target.value
                        );
                      }}
                    />

                    <input
                      className="coach-modal-input"
                      placeholder="Rank"
                      value={r.Rank || ""}
                      onChange={function (e) {
                        handleChangeRank(
                          r.Id,
                          "Rank",
                          e.target.value
                        );
                      }}
                    />

                    <button
                      className="coach-modal-rank-delete"
                      onClick={function () {
                        handleDeleteRank(r.Id);
                      }}
                    >
                       <DeleteIcon className="rank-delete-icon" />
                    </button>
                  </div>
                );
              })}

              <button
                className="coach-modal-rank-add"
                onClick={handleAddRank}
              >
                 <AddIcon className="rank-add-icon" />
                <span>Add Rank</span>
              </button>
            </div> */}
            <div className="coach-modal-ranks-block">
              <p className="coach-modal-label">Sıralama</p>
              <div className="coach-modal-rank-header">
                <span className="coach-modal-rank-header-spacer" />
                <span className="coach-modal-rank-header-spacer" />

                <span className="coach-modal-rank-header-title">Önizleme</span>
                <span className="coach-modal-rank-header-title">Özet</span>
              </div>
              {ranks.map(function (r) {
                return (
                  <div className="coach-modal-rank-row" key={r.Id}>
                    {/* FIXED — Exam SubType label */}
                    <input
                      className="coach-modal-input"
                      value={r.ExamSubType}
                      disabled
                      style={{
                        backgroundColor: "#e5e7eb",
                        cursor: "not-allowed",
                      }}
                    />

                    {/* Editable Rank */}
                    <input
                      className="coach-modal-input"
                      placeholder="-"
                      value={r.Rank || ""}
                      onChange={(e) => {
                        let value = e.target.value;

                        // Remove all non-digit characters
                        value = value.replace(/\D/g, "");

                        // Remove leading zeros
                        if (value.length > 1) {
                          value = value.replace(/^0+/, "");
                        }

                        handleChangeRank(r.Id, "Rank", value);
                      }}
                    />
                    <label className="coach-modal-toggle">
                      <input
                        type="checkbox"
                        checked={r.VisibleOnPreview}
                        onChange={(e) =>
                          handleChangeRank(
                            r.Id,
                            "VisibleOnPreview",
                            e.target.checked
                          )
                        }
                      />
                      <span className="coach-modal-toggle-slider" />
                    </label>
                    <label className="coach-modal-toggle">
                      <input
                        type="checkbox"
                        checked={r.VisibleOnSummary}
                        onChange={(e) =>
                          handleChangeRank(
                            r.Id,
                            "VisibleOnSummary",
                            e.target.checked
                          )
                        }
                      />
                      <span className="coach-modal-toggle-slider" />
                    </label>
                  </div>
                );
              })}
            </div>

            {/* TOGGLE + SEATS */}
            {/* <div className="coach-modal-toggle-block">
              <div className="coach-modal-toggle-text">
                <p className="coach-modal-toggle-title">
                  Koç Aktif mi?
                </p>
              </div>

              <label className="coach-modal-toggle">
                <input
                  type="checkbox"
                  checked={isSelectedCoach}
                  onChange={function (e) {
                    setIsSelectedCoach(e.target.checked);
                  }}
                />
                <span className="coach-modal-toggle-slider" />
              </label>
            </div> */}

            <label className="coach-modal-field">
              <p className="coach-modal-label">Toplam Koçluk Kontenjanı</p>

              <input
                type="number"
                className="coach-modal-input"
                value={totalSeats}
                onChange={function (e) {
                  if (e.target.value < 0) return;
                  setTotalSeats(e.target.value);
                }}
              />

              {mode === "edit" && (
                <span className="coach-modal-student-count">
                  Koçluk Alan Öğrenci Sayısı: <strong>{studentCount}</strong>
                </span>
              )}
            </label>
            <label className="coach-modal-field">
              <p className="coach-modal-label">Koçun Profil Sıralaması</p>

              <input
                type="number"
                className="coach-modal-input"
                value={coachOrder}
                onChange={function (e) {
                  if (e.target.value < 1) return;
                  setCoachOrder(e.target.value);
                }}
              />
            </label>
            <label className="coach-modal-field">
  <p className="coach-modal-label">Koç için Sınav Seçiniz</p>

  <select
    className="coach-modal-input"
    value={selectedExamCategoryId}
    onChange={(e) => setSelectedExamCategoryId(Number(e.target.value))}
  >
    {EXAM_CATEGORY_OPTIONS.map((opt) => (
      <option key={opt.id} value={opt.id}>
        {opt.label}
      </option>
    ))}
  </select>
</label>

          </div>
        </div>

        {/* FOOTER */}
        <div className="coach-modal-footer">
          <button
            className="coach-modal-btn coach-modal-btn-secondary"
            onClick={function () {
              if (onClose) onClose();
            }}
          >
            İptal
          </button>

          <button
            className="coach-modal-btn coach-modal-btn-primary"
            onClick={handleOpenPreview}
          >
            Değişiklikleri Kaydet
          </button>
        </div>
      </div>
      {/* PREVIEW DRAWER */}
      <CoachPreviewDrawer
        open={isPreviewOpen}
        payload={previewPayload}
        onCancel={handleCancelPreview}
        onConfirm={handleConfirmSave}
      />
    </div>
  );
}
